import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_URL } from '../../imports';

function AudioPlayer({filename, filetype}) {
  const [audioUrl, setAudioUrl] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/s3files/downloadfile`,
          {
            project_code: sessionStorage.getItem('projectCode'),
            file_name: filename,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
            responseType: 'json',
          }
        );

        // // Decode the base64-encoded content to binary
        // const binaryContent = atob(response.data.download_content);

        // // Create a Blob from the binary content
        // const blob = new Blob([new Uint8Array([...binaryContent].map((char) => char.charCodeAt(0)))], {
        //   type: 'audio/wav',
        // });

        // // Create a URL object from the Blob
        // const url = window.URL.createObjectURL(blob);

        setAudioUrl(response.data.download_content);
      } catch (error) {
        console.error('Error fetching audio:', error);
      }
    };

    fetchData();
  }, [filename]);

  return (
    <div className='p-3'>
      {audioUrl && (
        <audio controls>
          <source src={audioUrl} type={filetype} />
          Your browser does not support the audio tag.
        </audio>
      )}
    </div>
  );
}

export default AudioPlayer;
